module.exports = __webpack_public_path__ + "static/img/联系我们.f761efa.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/images/联系我们.png
// module id = yxpB
// module chunks = 45